import {
  AfterViewInit,
  Injector,
  OnDestroy,
  ViewChild,
  Directive,
  inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs';

import {
  $invokeWatchers,
  AbstractNavigationService,
  App,
  noop,
  Viewport,
  ScriptLoaderService,
  UtilsService,
  registerFnByExpr,
  $watch, isDefined,
  setAttr,
  getDataSource,
  runtimeEventManager,
  removeAttr
} from '@wm/core';

import { FragmentMonitor } from '../util/fragment-monitor';
import { AppManagerService } from '../services/app.manager.service';
import { commonPartialWidgets } from "./base-partial.component";
import { I18nService, ProjectService } from '@wms/app/services';
import { PageDirective } from '@wm/design-runtime';
import { getWatchIdentifier, getWidgetPropsByType, WidgetRef } from '@wm/components-base';
import { AppRef } from "@wms/app/design-container";
import { environment } from "@wms/app";
import { get, isFunction, isString, set } from 'lodash-es';

declare const _: any;

// export const commonPartialWidgets = {};

@Directive()
export abstract class BaseCustomWidgetComponent extends FragmentMonitor implements AfterViewInit, OnDestroy {
  Widgets: any;
  //Variables: any;
  Actions: any;
  App: AppRef;
  injector: Injector;
  customWidgetName: string;
  customWidgetType: string;
  activePageName: string;
  route: ActivatedRoute;
  appManager: AppManagerService;
  navigationService: AbstractNavigationService;
  router: Router;
  props: any;
  containerWidget: any;
  i18nService: I18nService;
  appLocale: any;
  // @ViewChild(PartialDirective) partialDirective;
  pageDirective: PageDirective;
  // Prefab: PrefabDirective;
  scriptLoaderService: ScriptLoaderService;
  Viewport: Viewport;
  compileContent = false;
  spa: boolean;
  events: any;

  destroy$ = new Subject();
  override viewInit$ = new Subject();
  private viewParent: any;
  // private renderer: Renderer2
  private projectService: ProjectService;

  abstract evalUserScript(prefabContext: any, appContext: any, utils: any): any;

  abstract getVariables(): any;
  abstract getExpressions(): any;
  private baseVariableService: any;

  getContainerWidgetInjector() {
    return this.containerWidget.inj || this.containerWidget.injector;
  }

  constructor(){
    super();
    this.baseVariableService = runtimeEventManager.getService('variableService');
  }

  override init() {
    let resolveFn: Function = () => { };
    const promise = new Promise((res) => resolveFn = res)
    this.App = inject(AppRef);
    //making the code compatible in both the JIT and AOT modes
    this.containerWidget = inject(WidgetRef);
    this.i18nService = inject(I18nService);
    this.scriptLoaderService = inject(ScriptLoaderService);
    this.Viewport = inject(Viewport);
    this.projectService = inject(ProjectService);

    // this.viewContainerRef = this.getContainerWidgetInjector().get(ViewContainerRef);
    // Replacing this.getContainerWidgetInjector().view.component as viewParent
    // this.viewParent = (this.viewContainerRef as any).parentInjector._lView[8];
    this.viewParent = this.containerWidget.viewParent;

    if (this.viewParent?.registerFragment) {
      this.viewParent.registerFragment();
    }

    // register functions for binding evaluation
    this.registerExpressions();
    this.initUserScript();
    this.registerProps(resolveFn);
    // Using promise to make sure the props are registered in the container widget before registering events, Otherwise no events will be registered
    promise.then(() => this.registerEvents());

    this.registerWidgets();
    // this.initVariables();

    this.activePageName = this.App.activePageName; // Todo: remove this
    this.registerPageProps();
    this.defineI18nProps();

    this.viewInit$.subscribe(noop, noop, () => {
      this.props = this.containerWidget.props;
    });

    // if(this.spa) {
    //     this.pageDirective = this.injector ? this.injector.get(SpaPageDirective) : inject(SpaPageDirective);
    // } else {
    //     this.pageDirective = this.injector ? this.injector.get(PageDirective) : inject(PageDirective);
    // }
    // if (this.pageDirective) {
    //     this.registerDestroyListener(this.pageDirective.subscribe('attach', (data: any) => this.ngOnAttach(data.refreshData)));
    //     this.registerDestroyListener(this.pageDirective.subscribe('detach', () => this.ngOnDetach()));
    // }

    super.init();
  }

  registerWidgets() {
    // common partial widgets should be accessible from page
    this.Widgets = Object.create(commonPartialWidgets);

    // expose current page widgets on app
    (this.App as any).Widgets = Object.create(this.Widgets);
  }

  invokeEvent = (eventName: string) => {
    this.events[eventName]();
  }

  registerEvents() {
    this.events = {};
    this.containerWidget.eventHandlers.forEach((callback: any, key: string) => {
      this.events[key] = (...args: any[]) => {
        this.containerWidget.invokeEventCallback(key, { $event: args[0], $data: args[1] });
      };
    });
  }

  registerDestroyListener(fn: Function) {
    this.destroy$.subscribe(noop, noop, () => fn());
  }

  registerChangeListeners() {
    this.containerWidget.registerPropertyChangeListener(this.onPropertyChange);
    this.containerWidget.registerStyleChangeListener(this.onPropertyChange);
  }

  initUserScript() {
    try {
      // partials inside prefab should have access to Prefab properties and events
      if (this.viewParent?.prefabName) {
        // for partial within partial within prefabs, just assign the parent partial's prefab object
        if (this.viewParent?.Prefab) {
          // this.Prefab = this.viewParent.Prefab;
        } else {
          // this.Prefab = this.viewParent;
        }
      }
      this.evalUserScript(this, this.App, this.injector ? this.injector.get(UtilsService) : inject(UtilsService));
    } catch (e) {
      console.error(`Error in evaluating partial (${this.customWidgetName}) script\n`, e);
    }
  }

  // initVariables() {
  //     const variablesService = this.injector ? this.injector.get(VariablesService) : inject(VariablesService);

  //     // get variables and actions instances for the page
  //     const variableCollection = variablesService.register(this.customWidgetName, this.getVariables(), this);

  //     // create namespace for Variables nad Actions on page/partial, which inherits the Variables and Actions from App instance
  //     this.Variables = Object.create(this.App.Variables);
  //     this.Actions = Object.create(this.App.Actions);

  //     this.containerWidget.Variables = this.Variables;
  //     this.containerWidget.Actions = this.Actions;

  //     // assign all the page variables to the pageInstance
  //     Object.entries(variableCollection.Variables).forEach(([name, variable]) => this.Variables[name] = variable);
  //     Object.entries(variableCollection.Actions).forEach(([name, action]) => this.Actions[name] = action);


  //     this.viewInit$.subscribe(noop, noop, () => {
  //         // TEMP: triggering watchers so variables watching over params are updated
  //         $invokeWatchers(true, true);
  //         variableCollection.callback(variableCollection.Variables).catch(noop);
  //         variableCollection.callback(variableCollection.Actions);
  //     });
  // }

  /**
   * function to register bind expressions generated in this partial instance
   * getExpressions function is defined in the generated page.comp.ts file
   * @param expressions, map of bind expression vs generated function
   */
  registerExpressions() {
    const expressions = this.getExpressions();
    _.each(expressions, (fn: any[], expr: any) => {
      registerFnByExpr(expr, fn[0], fn[1]);
    });
  }

  registerPageProps() {
    this.props = this.containerWidget.props;
  }

  defineI18nProps() {
    this.appLocale = this.i18nService.getAppLocale();
  }

  invokeOnReady() {
    let params;
    if (this.containerWidget.userComponentParams) {
      params = this.containerWidget.userComponentParams;
    }
    this.onReady(params);
    if (this.viewParent?.resolveFragment) {
      this.viewParent?.resolveFragment();
    }
  }

  private loadScripts() {
    // return new Promise<void>((resolve) => {
    //     const scriptsRequired = this.partialDirective.$element.attr('scripts-to-load');
    //     if (scriptsRequired) {
    //         this.scriptLoaderService
    //             .load(...scriptsRequired.split(','))
    //             .then(resolve);
    //     } else {
    //         resolve();
    //     }
    // });
  }
  registerProps(resolveFn: Function) {
    const projectId = this.projectService.getProjectId();
    const resourceUrl = environment.SERVICES_BASE_PATH + `services/projects/${projectId}/resources/content/project/src/main/webapp/custom-widgets/${this.customWidgetName}/page.min.json`;
    (window as any)['resourceCache'].get(resourceUrl).then(({ config }: { config: any }) => {
      if (config) {
        // Maintains widgetType as "wm-input-text" at runtime and "wm-text" in studio for text widget.  
        // TODO: Remove this handling and address it later.
        if (config.widgetType === "wm-input-text") 
            config.widgetType = "wm-text";
        this.customWidgetType = config.widgetType;
        const inheritedWidgetProps: { [key: string]: any; } = getWidgetPropsByType(this.customWidgetType);
        inheritedWidgetProps && Object.entries(inheritedWidgetProps).forEach(([k, v]) => {
          if (isDefined(v.value)) {
            (this as any)[k] = v.value;
          }
        });
        Object.entries((config.properties || {})).forEach(([key, prop]: [string, any]) => {
          let expr;
          const value = _.trim(prop.value);

          if (_.startsWith(value, 'bind:')) {
            expr = value.replace('bind:', '');
          }

          Object.defineProperty(this, key, {
            get: () => this.containerWidget[key],
            set: nv => this.containerWidget.widget[key] = nv
          });

          if (expr) {
            //[Todo-CSP]: expr will be generated with prefab.comp.expr.ts
            this.registerDestroyListener(
              $watch(expr, this, {}, (nv: any) => this.containerWidget.widget[key] = nv)
            );
          }
        })
      }
      this.containerWidget.setProps(config, resolveFn);
      // Reassigning the proxy handler for prefab inbound properties as we
      // will get them only after the prefab config call.
      // if (isIE()) {
      //     this.containerWidget.widget = this.containerWidget.createProxy();
      // }
    })
  }

  mute() {
    const m = (o: { mute: () => any; }) => { o && o.mute && o.mute(); };
    _.each(this.Widgets, m);
    _.each(this.Variables, m);
    _.each(this.Actions, m);
  }

  unmute() {
    const um = (o: { unmute: () => any; }) => { o && o.unmute && o.unmute(); };
    _.each(this.Widgets, um);
    _.each(this.Variables, um);
    _.each(this.Actions, um);
  }

  // ngOnInit() {
  //     this.init();
  // }

  ngAfterViewInit(): void {
    this.registerChangeListeners();
    setTimeout(() => {
      // trigger viewInit$.complete after a timeout so that the widget listeners are ready before Variable xhr call.
      this.viewInit$.complete();
      this.fragmentsLoaded$.subscribe(noop, noop, () => this.invokeOnReady());
    }, 100);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  ngOnAttach(refreshData: any) {
    this.unmute();
    if (refreshData) {
      const refresh = (v: { startUpdate: any; invoke: () => any; }) => { v && v.startUpdate && v.invoke && v.invoke(); };
      _.each(this.Variables, refresh);
      _.each(this.Actions, refresh);
    }
    _.each(this.Widgets, (w: { ngOnAttach: () => any; }) => w && w.ngOnAttach && w.ngOnAttach());
  }

  ngOnDetach() {
    this.mute();
    _.each(this.Widgets, (w: { ngOnDetach: () => any; }) => w && w.ngOnDetach && w.ngOnDetach());
  }

  // user overrides this
  onPropertyChange() {
    
  }

  onReady(params?: any) {
  }
  get Variables() {
    return {};
    // return this.baseVariableService.variableInstanceCollection[this.partialName];
  }
}
